import React from "react";
import TopBar from "./components/TopBar";
import Calibrate from "./components/Calibrate";

const HomePage = () => {
  return (
    <div>
      <TopBar />
      <Calibrate />
    </div>
  );
};

export default HomePage;
